<template>
    <CRow>
        <CCol>
            <CCard v-if="entity">
                <CCardHeader>
                    <strong>{{ entity.code }}</strong>
                </CCardHeader>
                <CCardBody>
                    <BannerTabLinks />
                    <BannerCard :entity="entity" />
                </CCardBody>

                <CCardFooter>
                    <CButton
                        color="primary"
                        @click="$router.push(`/banners`)"
                    >Назад</CButton
                    >
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import BannerTabLinks from '@/components/banners/BannerTabLinks';
    import BannerCard from '@/components/banners/BannerCard';

    export default {
        name: 'Banner',

        components: {
            BannerTabLinks,
            BannerCard,
        },

        data() {
            return {
                entity: undefined,
            };
        },

        async created() {
            await this.fetch();
        },

        methods: {
            async fetch() {
                const { id } = this.$route.params;
                this.entity = (await this.axios.get(`/banners/${id}`)).data;
            },
        },
    };
</script>
